import { createTheme } from '@mui/material/styles';

export const customTheme = createTheme({
  palette: {
    primary: {
      main: '#668355',
      light: '#8EA58C',
      lighter: '#BFCFBB'
    },
    secondary: {
      main: '#DDA15E',
      contrastText: '#ffffff'
    }, 
    background: {
      main: '#FAF9F6'
    },
    surface: {
      main: '#DAD7CD'
    },
    warning: {
      main: '#e42a43ff',
      dark: '#c32239',
      light: '#f05567'
    },
    //error: {
      //main: '#FFE7E7'
    //},
    text: {
      primary: '#333333',
      secondary: '#808080',
      disabled: '#B5B5B5'
    }
    //filters: {
    //  regions: '#3C6E9F',
    //  sectors: '#33A7CC',
    //  grouping: '#5A396F' 
    //}
  },
  typography: {
    fontFamily: 'Roboto, sans-serif',
    fontWeightRegular: 300,
    letterSpacing: "0.0125rem",
    button: {
      textTransform: "none",
      fontWeight: 600
    },
    h1: { //Page titles
      fontSize: '45px',
      fontStyle: 'normal',
      fontWeight: 500,
      lineHeight: '57px',
    },
    h2: {
      fontSize: '39px',
      fontStyle: 'normal',
    },
    h3: {
      fontSize: '31px',
      fontStyle: 'normal',
      fontWeight: '500',
    },
    h4: { //User Accounts Titles
      fontSize: '20px',
      fontStyle: 'normal',
      fontWeight: '600',
      lineHeight: '24px'
    }, 
    h5 : { //User Account subtitles
      fontSize: '16px',
      fontStyle: 'normal',
      fontWeight: '600',
      lineHeight: '19px'
    },
    h6 : { 
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: '600',
        lineHeight: '19px'
    },
    subtitle1: {
      fontSize: '14px', 
      fontWeight: 'bold',
    },
    body1: { 
      fontSize: '16px', 
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '19px'
    },
    body2: { //Smaller text
      fontSize: '12px', 
      fontStyle: 'normal',
      fontWeight: '300',
      lineHeight: '16px'
    },
    body3: { //Map popup
      fontSize: '10px', 
      fontStyle: 'normal',
      fontWeight: '300',
      lineHeight: '14px'
    }
  }
});

export { ThemeProvider, CssBaseline } from '@mui/material';
export { default as Typography } from '@mui/material/Typography';
